import { useEffect, useState } from "react";

// Shared download logic, used by the homepage hero/CTA and the blog post CTA so
// every "Download" button on the site resolves to the same platform-aware URL
// and label.

export const FALLBACK_VERSION = "0.3.3";

export type DownloadPlatform = "mac" | "windows" | "linux" | "latest";

export function getDownloadInfo(version: string): { url: string; platform: DownloadPlatform } {
  const base = `https://github.com/0-AI-UG/cate/releases/download/v${version}`;
  const ua = navigator.userAgent;
  if (/Mac/i.test(ua)) {
    return { url: `${base}/Cate-${version}-arm64.dmg`, platform: "mac" };
  }
  if (/Win/i.test(ua)) {
    return { url: `${base}/Cate.Setup.${version}.exe`, platform: "windows" };
  }
  if (/Linux/i.test(ua)) {
    return { url: `${base}/Cate-${version}.AppImage`, platform: "linux" };
  }
  return { url: `https://github.com/0-AI-UG/cate/releases/latest`, platform: "latest" };
}

export function useLatestVersion(): string {
  const [version, setVersion] = useState<string>(() => {
    try {
      const cached = sessionStorage.getItem("cate:latest-version");
      if (cached) return cached;
    } catch {}
    return FALLBACK_VERSION;
  });

  useEffect(() => {
    let cancelled = false;
    fetch("https://api.github.com/repos/0-AI-UG/cate/releases/latest", {
      headers: { Accept: "application/vnd.github+json" },
    })
      .then((r) => (r.ok ? r.json() : null))
      .then((data) => {
        if (cancelled || !data?.tag_name) return;
        const v = String(data.tag_name).replace(/^v/, "");
        setVersion(v);
        try { sessionStorage.setItem("cate:latest-version", v); } catch {}
      })
      .catch(() => {});
    return () => { cancelled = true; };
  }, []);

  return version;
}
